<template>
  <v-container fluid>
    <PageHeading
      mode="grid"
      :text="'Пользователи'"
      :grid-data-loading="gridDataLoading"
      :results-count="resultsCount"
    >
      <template v-slot:[`toolbar.prepend`]>
        <v-btn
          link
          small
          outlined
          color="primary"
          class="mx-2 mt-2"
          :to="{
            name: 'page-account-new'
          }"
        >
          <v-icon class="mr-2" small> mdi-plus </v-icon>
          Создать пользователя
        </v-btn>
      </template>
    </PageHeading>
    <v-row>
      <v-col>
        <GridAccounts ref="grid" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GridAccounts from './grid'
import PageHeading from '@/components/page-heading'
import gridPageInterface from '@/interfaces/grid-page-interface-mixin'

export default {
  name: 'PageAccounts',
  components: {
    PageHeading,
    GridAccounts
  },
  mixins: [gridPageInterface],
  metaInfo () {
    return {
      title: 'Пользователи'
    }
  }

}
</script>
